import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// THEMES
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { createTheme } from '@material-ui/core/styles';

// USER DEFINED
import Website from "./Components/Website";
import ScrollToTop from 'Components/ScrollToTop';
import { THEME_SETTINGS } from "./themeSettings";
import { UtilityStyles } from './Styles/Utils'
import { store } from "./Redux/Store";

const theme = createTheme(THEME_SETTINGS);

function App() {
	return (
		<Provider store={store}>
			<BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
				<ScrollToTop />
				<Suspense fallback={null}>
					<MuiThemeProvider theme={theme}>
						<Website />
						<UtilityStyles />
					</MuiThemeProvider>
				</Suspense>
			</BrowserRouter>
		</Provider>
	);
}

export default App;
